import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, withCtx as _withCtx, createBlock as _createBlock, createSlots as _createSlots, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-193c1ead"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DetailTitle = _resolveComponent("DetailTitle")!
  const _component_a_descriptions_item = _resolveComponent("a-descriptions-item")!
  const _component_a_descriptions = _resolveComponent("a-descriptions")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["description-list", { 'description-list-collapse': _ctx.collapse }])
  }, [
    _createVNode(_component_a_descriptions, {
      column: _ctx.collapse ? [] : _ctx.column,
      bordered: ""
    }, _createSlots({
      default: _withCtx(() => [
        (!_ctx.collapse)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.list, (val) => {
              return (_openBlock(), _createBlock(_component_a_descriptions_item, {
                key: val.prop,
                label: val.name,
                span: val.span,
                labelStyle: val.labelStyle,
                contentStyle: val.contentStyle
              }, {
                default: _withCtx(() => [
                  (!val.slot)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        onClick: ($event: any) => (val.click ? val.click(_ctx.currentData) : undefined)
                      }, _toDisplayString(!val.format ? _ctx.currentData[val.prop] : val.format(_ctx.currentData[val.prop], _ctx.currentData)), 9, _hoisted_1))
                    : _renderSlot(_ctx.$slots, val.slot, {
                        key: 1,
                        currentData: _ctx.currentData
                      }, undefined, true)
                ]),
                _: 2
              }, 1032, ["label", "span", "labelStyle", "contentStyle"]))
            }), 128))
          : _createCommentVNode("", true)
      ]),
      _: 2
    }, [
      (_ctx.title)
        ? {
            name: "title",
            fn: _withCtx(() => [
              _createVNode(_component_DetailTitle, {
                title: _ctx.title,
                collapse: _ctx.collapse,
                onCollapse: _ctx.onCollapseChange
              }, null, 8, ["title", "collapse", "onCollapse"])
            ]),
            key: "0"
          }
        : undefined
    ]), 1032, ["column"])
  ], 2))
}